export const SET_DOSSIERS = 'SET_DOSSIERS';
